import { rfcToShiftedDate } from '../DateAndTimeAdapters/dateTimeAdapter';
export default class DateTimeFormatter {
    constructor(regionalLocale, timezone) {
        this.regionalLocale = regionalLocale;
        this.timezone = timezone;
    }
    format(rfcDateTime, formatOptions) {
        const date = this.timezone
            ? new Date(rfcDateTime)
            : rfcToShiftedDate(rfcDateTime);
        const dateTimeFormat = new Intl.DateTimeFormat(this.regionalLocale, {
            ...formatOptions,
            timeZone: this.timezone,
        });
        return dateTimeFormat.format(date);
    }
    /**
     * @param {string} rfcDateTime - example 2020-05-16T13:00:00.000+03:00
     * @returns {string} Wednesday, 2 June
     */
    formatDayOfMonth(rfcDateTime) {
        const formatOptions = {
            day: 'numeric',
            weekday: 'long',
            month: 'long',
        };
        return this.format(rfcDateTime, formatOptions);
    }
    // TimePicker header
    /**
     * @param {string} rfcDateTime - example 2020-05-16T13:00:00.000+03:00
     * @returns {string} 13:30
     */
    formatTime(rfcDateTime) {
        const formatOptions = {
            hour: 'numeric',
            minute: 'numeric',
        };
        return this.format(rfcDateTime, formatOptions).toLowerCase();
    }
    // RescheduleDialog, TimePicker timeslot
    // RescheduleToast - need to integrate
    /**
     * @param {string} rfcDateTime - example 2020-05-16T13:00:00.000+03:00
     * @returns {string} 2 June 2021
     */
    formatDate(rfcDateTime) {
        const formatOptions = {
            day: 'numeric',
            year: 'numeric',
            month: 'long',
        };
        return this.format(rfcDateTime, formatOptions);
    }
    /**
     * @param {string} rfcDateTime - example 2020-05-16T13:00:00.000+03:00
     * @returns {string} 18 Jun
     */
    formatShortDate(rfcDateTime) {
        const formatOptions = {
            month: 'short',
            day: 'numeric',
        };
        return this.format(rfcDateTime, formatOptions);
    }
    // RescheduleDialog, RescheduleToast
    /**
     * @param {string} rfcDateTime - example 2020-05-16T13:00:00.000+03:00
     * @returns {string}  2 June 2021, 13:30
     */
    formatDateAndTime(rfcDateTime) {
        const formatOptions = {
            day: 'numeric',
            year: 'numeric',
            month: 'long',
            hour: 'numeric',
            minute: 'numeric',
        };
        return this.format(rfcDateTime, formatOptions)
            .replace('AM', 'am')
            .replace('PM', 'pm');
    }
    // Booking Details
    /**
     * @param {string} rfcDateTime - example 2020-09-04T00:00:00.000+03:00
     * @returns {string} 4
     */
    formatDay(rfcDateTime) {
        const formatOptions = {
            day: 'numeric',
        };
        return this.format(rfcDateTime, formatOptions);
    }
    /**
     * @param {string} rfcDateTime - example 2020-09-04T00:00:00.000+03:00
     * @returns {string} Fri
     */
    formatShortWeekday(rfcDateTime) {
        const formatOptions = {
            weekday: 'short',
        };
        return this.format(rfcDateTime, formatOptions);
    }
    /**
     * @param {string} rfcDateTime - example 2020-09-04T00:00:00.000+03:00
     * @returns {string} Friday
     */
    formatWeekday(rfcDateTime) {
        const formatOptions = {
            weekday: 'long',
        };
        return this.format(rfcDateTime, formatOptions);
    }
    /**
     * @param {string} rfcDateTime - example 2020-09-04T00:00:00.000+03:00
     * @returns {string} September
     */
    formatMonth(rfcDateTime) {
        const formatOptions = {
            month: 'long',
        };
        return this.format(rfcDateTime, formatOptions);
    }
}
//# sourceMappingURL=DateTimeFormatter.js.map